import React from 'react';

const TruncatedText = ({ text, width }) => (
  <div style={{
    width: width,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight:400,
  }}>
    {text}
  </div>
);

export default TruncatedText;